module.exports = __webpack_public_path__ + "img/icon_i.d42507a4.svg";